import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ContentContainer from './ContentContainer';

class DataPrivacyContent extends React.Component {
    render() {
        const { texts } = this.props;
        return (
            <ContentContainer>
                <h1>{texts['title']}</h1>

                <h2>{texts['privacy.title']}</h2>
                <p>{texts['privacy.copy']}</p>

                <h2>{texts['personal.data.title']}</h2>
                <p>{texts['personal.data.copy']}</p>

                <h2>{texts['choose.title']}</h2>
                <p>{texts['choose.copy']}</p>

                <h2>{texts['information.title']}</h2>
                <p>{texts['information.copy']}</p>

                <h2>{texts['ga.title']}</h2>
                <p>{texts['ga.copy']}</p>
            </ContentContainer>
        );
    }
}

DataPrivacyContent.propTypes = {};

DataPrivacyContent.defaultProps = {};

function mapStateToProps(state) {
    return {
        texts: {
            title: state.app.texts['data.privacy.title'],
            'privacy.title': state.app.texts['data.privacy.privacy.title'],
            'privacy.copy': state.app.texts['data.privacy.privacy.copy'],
            'personal.data.title': state.app.texts['data.privacy.personal.data.title'],
            'personal.data.copy': state.app.texts['data.privacy.personal.data.copy'],
            'choose.title': state.app.texts['data.privacy.choose.title'],
            'choose.copy': state.app.texts['data.privacy.choose.copy'],
            'information.title': state.app.texts['data.privacy.information.title'],
            'information.copy': state.app.texts['data.privacy.information.copy'],
            'plugins.title': state.app.texts['data.privacy.plugins.title'],
            'plugins.copy': state.app.texts['data.privacy.plugins.copy'],
            'ga.title': state.app.texts['data.privacy.ga.title'],
            'ga.copy': state.app.texts['data.privacy.ga.copy'],
        },
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DataPrivacyContent);
